export type InputMode = "planning" | "description";

export function normalizeInputMode(x: unknown): InputMode {
  return x === "planning" ? "planning" : "description";
}
